import "./lib/rails";
import "./lib/third_party_libs";

// TODO: this should be set according to the current locale
setAppConfiguration("locale", "en");

console.debug("[Boot] Register Confinus JS Components");
// Prepare client side controllers
import { application } from "./controllers";
import { register as registerDecorControllers } from "decor";
import { setAppConfiguration } from "lib/app_configuration";

// Off in production: build:js defines process.env.NODE_ENV from the deploy env
// (esbuild has no built-in default beyond "development", so the define in
// package.json is what makes this real). Debug logs Stimulus's circular
// Application object, which the Honeybadger console breadcrumb chokes on.
// @ts-ignore
application.debug = process.env.NODE_ENV === "development";

// Register Decor's Stimulus controllers (Vident-matching identifiers).
registerDecorControllers(application);
